import axios from 'axios';

const featureFlipperApi = axios.create({
  baseURL: `/course-evaluations/student/feature-flipper`,
});

export const isEvaluationExperienceEnabled = async (brandId) => {
    const params = { brandId: brandId };
    let { data } = await featureFlipperApi.get('/evaluation-experience', { params });
    return data;
}